import { useState, useEffect } from 'react';

/**
 * Reads the cached vendor / customer session from localStorage.
 *
 * Auth is now in an httpOnly cookie (`tgm_vendor_jwt` / `tgm_customer_jwt`) that
 * is NOT readable from JS. The header therefore treats the *cached profile*
 * (`tgmart_vendor` / `tgmart_user`) as the logged-in signal. The legacy tokens
 * are still accepted so sessions started before the cookie migration continue
 * to work until their JWT expires.
 */
export const readSession = () => {
  try {
    const vendorRaw = localStorage.getItem('tgmart_vendor');
    const vendorToken = localStorage.getItem('tgmart_vendor_token');
    if (vendorRaw || vendorToken) {
      const v = vendorRaw ? JSON.parse(vendorRaw) : {};
      return { role: 'vendor', name: v.name || 'Vendor', id: v.id };
    }
    const userRaw = localStorage.getItem('tgmart_user');
    const customerToken = localStorage.getItem('tgmart_token');
    if (userRaw || customerToken) {
      const u = userRaw ? JSON.parse(userRaw) : {};
      return { role: 'customer', name: u.name || 'Account', id: u.id };
    }
  } catch (err) {
    console.warn('Header: failed to read session from localStorage', err);
  }
  return null;
};

export const useSession = () => {
  const [session, setSession] = useState(() => readSession());
  useEffect(() => {
    const sync = () => setSession(readSession());
    window.addEventListener('storage', sync);
    window.addEventListener('tgmart-session-change', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('tgmart-session-change', sync);
    };
  }, []);
  return [session, setSession];
};
